namespace Ir.Components.Filters.NullButton {

    interface IViewModel{
        nullSettings: DevExpress.ui.dxButtonGroup.Properties;
    }

    export interface INullButtonParams {
        filter: Filter;
        onItemClick: (e) => void;
        visible?: boolean;
    }
    interface IParams {
        config: INullButtonParams;
    }

    export function getViewModel(this: IViewModel, params: IParams, componentInfo) {
        this.nullSettings = {
            visible: params.config.visible === undefined ? true : params.config.visible,
            items: [{
                icon: 'ms ir-null-icon',
                id: null,
                hint: 'Filter by null value',
            } as any],
            keyExpr: 'id',
            stylingMode: 'outlined',
            selectedItemKeys: ko.computed(() => [params.config.filter.startCondition()]) as any,
            onItemClick(e) {
                params.config.onItemClick(e);
            }
        };
    }
}